(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeEls = document.querySelectorAll('[data-drawer-close]');
  if(!drawer || !openBtn) return;

  function openDrawer(){
    drawer.setAttribute('data-open','');
    drawer.setAttribute('aria-hidden','false');
    openBtn.setAttribute('aria-expanded','true');
    document.body.classList.add('hdr-drawer-open');
  }
  function closeDrawer(){
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden','true');
    openBtn.setAttribute('aria-expanded','false');
    document.body.classList.remove('hdr-drawer-open');
  }

  openBtn.addEventListener('click', openDrawer);
  closeEls.forEach(function(el){ el.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
